import {
  DocumentMargins,
  DocumentOrientation,
  DocumentPageSize,
  DocumentViewMode,
} from 'containers/Tiptap/components/tiptap-extension/document-settings-yjs';

export const VIEW_MODE_OPTIONS: { value: DocumentViewMode; label: string }[] = [
  { value: DocumentViewMode.Pages, label: 'Pages' },
  { value: DocumentViewMode.Pageless, label: 'Pageless' },
];

export const PAGE_SIZE_OPTIONS: { value: DocumentPageSize; label: string }[] = [
  { value: 'A4', label: 'A4 (210 × 297 mm)' },
  { value: 'A3', label: 'A3 (297 × 420 mm)' },
  { value: 'A5', label: 'A5 (148 × 210 mm)' },
  { value: 'USLetter', label: 'US Letter (216 × 279 mm)' },
  { value: 'USLegal', label: 'US Legal (216 × 356 mm)' },
  { value: 'Tabloid', label: 'Tabloid (279 × 432 mm)' },
];

export const ORIENTATION_OPTIONS: { value: DocumentOrientation; label: string }[] = [
  { value: 'portrait', label: 'Portrait' },
  { value: 'landscape', label: 'Landscape' },
];

export const MARGINS_OPTIONS: { value: DocumentMargins; label: string }[] = [
  { value: 'narrow', label: 'Narrow (12.7 mm)' },
  { value: 'normal', label: 'Normal (25.4 mm)' },
  { value: 'wide', label: 'Wide (38.1 mm)' },
];

// Pages mode has known limitations we cannot fully resolve on our side (see the
// Tiptap issues register). We surface them to users up front — once inline when
// they select Pages, and again in the confirmation before the switch is applied.
export const PAGES_INLINE_WARNING =
  'Complex content, such as risk matrices, may not split neatly across pages. ' +
  'Exported PDF and Word files can differ slightly from what you see on screen.';

export const PAGES_LIMITATIONS = [
  'Complex content, such as risk matrices, may stay on a single page instead of splitting across pages.',
  'Exported PDF and Word files may not exactly match the on-screen spacing and page breaks.',
];
